<template>
  <v-dialog v-model="visible" width="900px" @click:outside="$emit('close')">
      <v-card class="overflow-x-hidden">
        <v-row class="fill-height overflow-auto container">
            <v-col cols="5">
                <div class="item-img text-center">
                    <img :src="item.img" />
                </div>
            </v-col>
            <v-col cols="7">
                <v-icon class="close" @click="$emit('close')">mdi-close</v-icon>
                <div class="item-details">
                    <div class="title">
                        <h3>{{ item.name }}</h3>
                        <p>${{ formatAmount(item.price) }}</p>
                        <div class="d-flex justify-lg-space-between">
                            <div class="rating">
                                <template v-for="i in 5">
                                    <v-icon size="16" :key="i" :color="i > item.rating ? 'grey lighten-1' : 'yellow darken-1'">
                                        {{ i > item.rating ? 'mdi-star-outline' : 'mdi-star' }}
                                    </v-icon>
                                </template>
                            </div>

                            <p>In Stock: {{ item.qty }}</p>
                        </div>
                    </div>

                    <div class="description">
                        <p>{{ item.desc }}</p>
                    </div>

                    <form class="form">
                        <div class="quantity">
                            <input type="number" step="1" min="1" v-model="quantity" />

                            <div class="qty">
                                <div @click="quantity+= (quantity < item.qty) ? 1 : 0"><v-icon>mdi-arrow-up</v-icon></div>
                                <div @click="quantity -= (quantity > 1) ? 1 : 0"><v-icon>mdi-arrow-down</v-icon></div>
                            </div>
                        </div>
                        <div class="add-cart flex-column">
                            <v-btn
                                color="#FF6F6A"
                                dark
                                depressed
                                style="height: 43px"
                                @click="removeItem"
                                v-if="isInCart"
                            >
                                Remove
                            </v-btn>

                            <v-btn
                                v-else
                                color="primary"
                                dark
                                depressed
                                style="height: 43px"
                                @click="addToCart"
                            >
                                Add To Cart
                            </v-btn>
                        </div>
                    </form>
                </div>
            </v-col>
        </v-row>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        item: Object,
    },
    data: () => ({
        quantity: 1,
    }),
    methods: {
        removeItem() {
            this.$store.commit('removeFromCart', this.item);
            this.$swal({
                type: 'success',
                text: 'Item has been removed from the cart',
            });
        },
    },
    computed: {
        isInCart() {
            const found = this.$store.state.shoppingList.find(key => key.id === this.item.id && key.brand === this.item.brand);
            return found ? true : false;
        },
    },
}
</script>

<style scoped>
.item-img img {
    width: 300px;
    height: 250px;
}

.item-details .title h3 {
        color: #232323;
    font-size: 20px;
    line-height: 22px;
    font-weight: 500;
}

.item-details .title p {
    color: #232323;
    font-weight: 400;
    font-size: 18px;
    margin: 0;
}

.close {
    position: absolute;
    right: 0;
    top: 0;
    color: #fff;
    background: #000;
    padding: 5px;
    cursor: pointer;
}

.item-details .description {
    border-top: 1px solid #e8e8e8;
    margin: 25px 0 0 0;
    padding: 23px 0 0 0;
    line-height: 23px;
    font-weight: 400;
}

.item-details .description p {
    margin: 0;
    padding: 0;
}

.item-details form {
        border-top: 1px solid #e8e8e8;
    margin: 25px 0 0 0;
    padding: 25px 0 0 0;
    display: flex;
}

.item-details form .quantity {
    margin-right: 10px;
}

.item-details form .quantity input {
    padding: 5px 12px;
    font-size: 1.2rem;
    border: 2px solid #000;
    border-radius: 6px;
    width: 50px;
}

.item-details form .quantity input[type=number]::-webkit-inner-spin-button,
.item-details form .quantity input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.item-details form .quantity .qty {
    position: absolute;
    margin-top: -45px;
    margin-left: 30px;
    padding: 5px 0;
}

.item-details form .quantity .qty div {
    height: 15px;
}

.item-details form .quantity .qty .v-icon.v-icon {
    font-size: 14px;
    padding: 0;
    margin: 0;
    color: #000;
}
</style>